import accordion from './accordion'
import alert from './alert'
import badge from './badge'
import breadcrumb from './breadcrumb'
import button from './button'
import calendar from './calendar'
import checkbox from './checkbox'
import chip from './chip'
import commandPalette from './command-palette'
import formField from './form-field'
import input from './input'
import inputNumber from './input-number'
import modal from './modal'
import pagination from './pagination'
import popover from './popover'
import radioGroup from './radio-group'
import select from './select'
import slideover from './slideover'
import table from './table'
import tabs from './tabs'
import textarea from './textarea'
import tooltip from './tooltip'

export { default as colors } from './colors'
export { default as icons } from './icons'

export const themes = {
  accordion,
  alert,
  badge,
  breadcrumb,
  button,
  calendar,
  checkbox,
  chip,
  commandPalette,
  formField,
  input,
  inputNumber,
  modal,
  pagination,
  popover,
  radioGroup,
  select,
  slideover,
  table,
  tabs,
  textarea,
  tooltip,
}
